import { render } from "./FreeView.vue?vue&type=template&id=6bb289c2&scoped=true"
import script from "./FreeView.vue?vue&type=script&lang=js"
export * from "./FreeView.vue?vue&type=script&lang=js"

import "./FreeView.vue?vue&type=style&index=0&id=6bb289c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb289c2"]])

export default __exports__